import { React, useEffect, useState } from "react";
import { styled } from "styled-components";
import RecipeCard from "../components/Recipecard";
import RecipeCardSkeleton from "../components/RecipeCardSkeleton";
import Loader from "../components/Loader";
import axios from "axios";

const Container = styled.div`
  display: flex;
  padding: 0px 20px 40px 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  flex: 1 auto;
  align-self: stretch;
`;

const RecipeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  width: 100%;
`;

const LoadMoreSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  justify-content: space-evenly;
  padding: 40px 0px 40px 0px;
`;

const LoadMoreButton = styled.button`
  font-size: 18px;
  padding: 5px;
  border: 1px solid ${({ theme }) => theme.colorPrimary};
  background-color: ${({ theme }) => theme.colorPrimary};
  color: ${({ theme }) => theme.colorOnBackground};

  border-radius: 8px;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.colorPrimary};
  }
`;

const PAGE_SIZE = 12;

const Home = ({ type }) => {
  const [videos, setVideos] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      setIsLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/videos/${type}?offset=0&limit=${PAGE_SIZE}`,
        { withCredentials: true }
      );
      setVideos(res.data);
      setHasMore(res.data.length === PAGE_SIZE);
      setPage(1);
      setIsLoading(false);
      setIsInitialLoad(false);
    };
    fetchVideos();
  }, [type]);

  const fetchMoreData = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const offset = page * PAGE_SIZE;
      const res = await axios.get(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/videos/${type}?offset=${offset}&limit=${PAGE_SIZE}`,
        { withCredentials: true }
      );
      setVideos((prevVideos) => [...prevVideos, ...res.data]);
      setHasMore(res.data.length === PAGE_SIZE);
      setPage((prevPage) => prevPage + 1);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <RecipeGrid>
        {isInitialLoad
          ? Array.from({ length: PAGE_SIZE }).map((_, i) => (
              <RecipeCardSkeleton key={i} />
            ))
          : videos.map((video, index) => (
              <RecipeCard key={video._id + index} video={video} />
            ))}
      </RecipeGrid>
      {!isInitialLoad && (
        <LoadMoreSection>
          {isLoading && <Loader />}
          {hasMore && !isLoading ? (
            <LoadMoreButton onClick={fetchMoreData}>Load More</LoadMoreButton>
          ) : (
            <p>You've reached the end. Wow!</p>
          )}
        </LoadMoreSection>
      )}
    </Container>
  );
};
export default Home;
